var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: `${_vm.block}` },
    [
      _vm._t(
        "open-button",
        function () {
          return [
            _c(
              "button",
              {
                class: `${_vm.block}__${_vm.openButtonElement}`,
                on: { click: _vm.openModal },
              },
              [_vm._v("\n            Open Modal\n        ")]
            ),
          ]
        },
        { openModal: _vm.openModal }
      ),
      _vm._v(" "),
      _vm.open
        ? _c(
            "MountingPortal",
            { attrs: { "mount-to": "#modal", append: "" } },
            [
              _c(
                "div",
                {
                  class: `${_vm.block}__${_vm.overlayElement}`,
                  on: { click: _vm.clickOut },
                },
                [
                  _c(
                    "div",
                    {
                      ref: "modalWrapper",
                      class: `${_vm.block}__${_vm.wrapperElement}`,
                    },
                    [
                      _c(
                        "div",
                        {
                          ref: "modalContainer",
                          class: `${_vm.block}__${_vm.containerElement}`,
                        },
                        [
                          _c(
                            "div",
                            {
                              ref: "modalContent",
                              class: `${_vm.block}__${_vm.contentElement}`,
                              attrs: { tabindex: "0" },
                            },
                            [_vm._t("default")],
                            2
                          ),
                          _vm._v(" "),
                          _vm.loading
                            ? _vm._t(
                                "loading-spinner",
                                function () {
                                  return [
                                    _c("img", {
                                      class: `${_vm.block}__${_vm.loadingSpinnerElement}`,
                                      attrs: {
                                        src: "/media/spinner.gif",
                                        alt: "",
                                      },
                                    }),
                                  ]
                                },
                                { loading: _vm.loading }
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._t(
                        "close-button",
                        function () {
                          return [
                            _c(
                              "button",
                              {
                                class: `${_vm.block}__${_vm.closeButtonElement}`,
                                on: { click: _vm.closeModal },
                              },
                              [
                                _vm._v(
                                  "\n                        Close Modal\n                        "
                                ),
                                _c(
                                  "svg",
                                  {
                                    class: `${_vm.block}__${_vm.closeButtonIconElement}`,
                                    attrs: { viewBox: "0 0 320 512" },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        fill: "currentColor",
                                        d: "M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                        { closeModal: _vm.closeModal }
                      ),
                    ],
                    2
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }